import { cn } from '@/lib/utils';

type BrandSize = 'sm' | 'md' | 'lg';
type BrandTone = 'default' | 'inverse';

const MARK_SRC_DEFAULT = '/logo/valiosas-mark.svg';
const MARK_SRC_INVERSE = '/logo/valiosas-mark-white.svg';

const sizeStyles: Record<BrandSize, { root: string; mark: string; word: string; meta: string }> = {
  sm: {
    root: 'gap-2',
    mark: 'h-8 w-8 text-[13px]',
    word: 'text-sm',
    meta: 'text-[10px]',
  },
  md: {
    root: 'gap-3',
    mark: 'h-10 w-10 text-base',
    word: 'text-base',
    meta: 'text-xs',
  },
  lg: {
    root: 'gap-3',
    mark: 'h-12 w-12 text-lg',
    word: 'text-xl',
    meta: 'text-sm',
  },
};

export interface BrandProps {
  size?: BrandSize;
  tone?: BrandTone;
  subtitle?: string;
  className?: string;
  markClassName?: string;
}

export function Brand({
  size = 'md',
  tone = 'default',
  subtitle,
  className,
  markClassName,
}: BrandProps) {
  const styles = sizeStyles[size];
  const inverse = tone === 'inverse';

  return (
    <div className={cn('flex min-w-0 items-center', styles.root, className)} aria-label="ValiosasCRM">
      <img
        src={inverse ? MARK_SRC_INVERSE : MARK_SRC_DEFAULT}
        alt=""
        aria-hidden="true"
        className={cn('shrink-0 object-contain', styles.mark, markClassName)}
      />
      <span className="min-w-0">
        <span className={cn('block truncate font-bold leading-tight', styles.word, inverse ? 'text-white' : 'text-[#1C1D21]')}>
          ValiosasCRM
        </span>
        {subtitle ? (
          <span className={cn('block truncate leading-tight', styles.meta, inverse ? 'text-white/72' : 'text-[#8181A5]')}>
            {subtitle}
          </span>
        ) : null}
      </span>
    </div>
  );
}
